import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Business from "@/pages/business/page";
import Company from "@/pages/company/page";
import Recruit from "@/pages/recruit/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail";
import Contact from "@/pages/contact/page";
import Thanks from "@/pages/thanks/page";

const routes: RouteObject[] = [
  { path: "thanks", element: <Thanks /> },
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "business", element: <Business /> },
      { path: "company", element: <Company /> },
      { path: "recruit", element: <Recruit /> },
      { path: "news", element: <News /> },
      { path: "news/:slug", element: <NewsDetail /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;
